import type { FaireProductEntity } from "../../entity_types/product";

export const faire_table2_9: FaireProductEntity = {
  token: "faire_table2_9",
  type: "product",
  name: "Bergamot Still Life Art Print",
  brandName: "Candle Brand",
  imageUrl: "",
  priceDollars: 18,
  msrpDollars: 36,
  description: "Migrated candle ops mock product",
  tags: ["candle", "ops"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
